import React from 'react'
import VipHeader from './VipHeader'
import VipFooter from './VipFooter'
import '../../styles/vip.css'

interface VipLayoutProps {
  children: React.ReactNode
}

const VipLayout: React.FC<VipLayoutProps> = ({ children }) => {
  return (
    <div className="vip-layout">
      <VipHeader />
      <main>{children}</main>
      <VipFooter />
    </div>
  )
}

export default VipLayout
